var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4"},[_c('EventSubscriptionsRulesTable',{attrs:{"event-id":_vm.$route.params.eventId,"subscription-id":_vm.$route.params.subscriptionId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }